import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

// Cap a percentage at 100 for STUDENT-facing display only. Bonus marks let a
// student's internal score exceed 100% (counted in the weighted average), but
// students should never SEE a number above 100. Teacher/admin views must use
// the raw value, not this helper. Passes null/NaN through untouched and leaves
// any value <=100 unchanged (decimals preserved for callers that toFixed()).
export function displayPercent(p) {
  if (p == null || Number.isNaN(Number(p))) return p;
  return Math.min(100, Number(p));
}
